import React, { useState, useEffect } from 'react';
import { Pie } from 'react-chartjs-2';
import styles from './SiteViewChart.module.scss';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

const SiteViewChart = (props) => {
	const { apsStatusArr, leadsNum } = props;

	const data = {
		datasets: [
			{
				data: [leadsNum, apsStatusArr],
				backgroundColor: [
					'rgba(67, 138, 254, 0.3)',
					'rgba(67, 138, 254, 1)',
				],
				borderWidth: 1,
				datalabels: {
					display: false, // hide data number on chart
				},
			},
		],
	};

	const options = {
		plugins: {
			tooltip: {
				enabled: false,
			},
		},
		animation: false,
	};
	console.log('site view data', leadsNum);

	return (
		<div className={styles.site_view_chart}>
			<div className={styles.pie_chart}>
				<Pie options={options} data={data} />
			</div>
			<div className={styles.legends}>
				<div className={styles.legend_group}>
					<FiberManualRecordIcon
						style={{
							color: 'rgba(67, 138, 254, 0.3)',
							fontSize: '10px',
						}}
					/>
					<span style={{ fontSize: '10px' }}>Leads</span>
				</div>
				<div className={styles.legend_group}>
					<FiberManualRecordIcon
						style={{
							color: 'rgba(67, 138, 254, 1)',
							fontSize: '10px',
						}}
					/>
					<span style={{ fontSize: '10px' }}>Purchasers</span>
				</div>
			</div>
		</div>
	);
};

export default SiteViewChart;
